import React, { useEffect, useState } from "react";
import { StaticDateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import 'dayjs/locale/en-gb';
import { TextField } from "@mui/material";
import { getTheme } from "../../functions/themeService/themeService";
import { setDateTime } from "../../redux/actions/setDateTimeAction";

const DatePicker = (props) => {
    const { changeDate, date } = props;
    const theme = getTheme();
    const dispatch = useDispatch(); 
    const [selectedDate, setSelectedDate] = useState(null);
    const handleDateChange = (newDate) => {
        if (newDate && dayjs(newDate).isValid()) {
            let updatedDate = dayjs(newDate).format(); 
            setSelectedDate(updatedDate);
            dispatch(setDateTime(updatedDate)); 
        } else {
            console.error("Invalid date provided");
        }
    };
    useEffect(() => {
        setSelectedDate(date);
    }, [date]);
    

    return (
        <div className="muiDatePicker" style={{ color: 'initial' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb"
                localeText={{ okButtonLabel: '', cancelButtonLabel: '' }}
            >
            <StaticDateTimePicker 
                views={['year', 'month', 'day', 'hours', 'minutes']}
                closeOnSelect={false}

                renderInput={(params) => (
                    <TextField  {...params} />
                )}
                value={selectedDate ? dayjs(selectedDate) : dayjs()}
                defaultValue={ selectedDate?dayjs(selectedDate):dayjs()}
                onChange={handleDateChange}
                onKeyDown={(e) => {
                    e.preventDefault();
                    }}
                    sx={{
                        "& .MuiPickersDay-root": {
                            fontSize: '1.5rem'
                        },
                        "& .MuiIconButton-root": {
                            fontSize: '1.5rem'
                        },
                        "& .MuiTypography-root": {
                            fontSize: '1.5rem'
                        },
                        "& .MuiPickersToolbarText-root": {
                            fontSize: '1.5rem'
                        },
                        "& .MuiIconButton-caption": {
                            fontSize: '1.5rem'
                        },
                        "& .MuiPickersCalendarHeader": {
                            fontSize: '1.5rem'
                        },
                        "& .MuiClock-squareMask": {
                            fontSize: '1.5rem'
                        }
                    }}
            />
            </LocalizationProvider>
        </div>
    );
};

export default DatePicker;



